module.exports = __webpack_public_path__ + "media/bootstrap-icons/hdd-stack-fill-7931203d.svg";